<template>

    <v-app class="pa-0 ma-0" id="mainhomecontainer" >
        <v-card  class=" " elevation=0 >

            <v-system-bar
                flat
                color="transparent"

                height="30"
                class="pt-3">
                <v-row>
                    <v-col cols="12">
                        <!-- <div class="">YOUR FA<span><v-icon class="mr-0"
                        color= "#FE5800"
                            size="1.8rem">mdi-heart</v-icon></span>ORITES</div> -->
                            <div class="headline font-weight-bold pt-8 text-center">{{$t('zz_your_order')}}</div>
                    </v-col>
                </v-row>
            </v-system-bar>

            <v-card-text class="mb-auto">
                        <v-overlay v-model="orderoverlayPlain" z-index="99999" >
                            <v-progress-circular indeterminate size="64"></v-progress-circular>
                        </v-overlay>
                        <v-overlay v-model="overlaycocacola" z-index="99999">

                            <img :src="cocacolaImg" style="height:250px;max-width:auto !important;display:inline !important;"/>
                        </v-overlay>

                        <!-- ORDERING TEXT  -->
                        <v-row>

                            <v-col cols="12" class="mt-10">
                                {{$t('zz_order_top_text')}}
                            </v-col>
                        </v-row>

                        <v-row>

                            <v-col cols="12" class="pt-0" v-for="(course,index) in ordercourses.courses" :key="index" >
                                <v-row v-if="course.items.length>0">
                                    <v-col cols="12" class="pt-0">
                                    <div class="order-card-title-divider">
                                        <div>
                                        <!-- <div class="titlecontent text-center primary--text font-weight-bold" style="font-size:20px;"> -->
                                                <v-row>
                                                    <!-- <v-row class="fill-height" align="center"> -->
                                                    <v-col cols="12" class="order-card-divider-text">
                                                        <span>{{course.coursename}}</span>
                                                    </v-col>
                                                </v-row>
                                            </div></div>
                                    </v-col>
                                </v-row>

                                    <v-row align="center" >
                                        <v-col cols="12" v-for="(item,ind) in course.items" :key="ind" class="pa-2">
                                            <!-- <a @click.stop="fooditemdetails(item.itemid,item.courseid,course.type,item.sepretor)" > -->
                                                <v-card class="Card Outline Style Here" tile v-if="course.type=='food' || course.type=='drink'">
                                                    <v-row class="ma-0 pa-0">
                                                        <v-col cols="4" class=" pl-0 pr-0 pt-0 pb-0">
                                                            <v-img contain :src="item.image" class="order-card-image">

                                                            </v-img>
                                                        </v-col>

                                                        <v-col cols="8" class="ma-0 pa-0">
                                                            <v-row class="ma-0 pa-0">
                                                                <v-col cols="10" class="ma-0 pa-0">
                                                                    <p class="order-card-title">
                                                                        {{item.title}}</p>
                                                                </v-col>
                                                                <v-col cols="2" class="ma-0 pa-0 text-right">
                                                                    <v-icon @click.stop="deleteorderitem(item.itemid,item.courseid)" class="color:red" size="24" >mdi-close</v-icon>

                                                                    <!-- <v-icon @click.prevent="$emit('deleteitem',item.itemid,item.courseid)"   class="color:red" size="24" >mdi-close</v-icon> -->
                                                                </v-col>
                                                                <v-col cols="12" class="ma-0 pa-0">
                                                                    <p class="order-card-subtitle">{{item.subtitle}}</p>
                                                                </v-col>
                                                                <v-col cols="12" class="order-card-price">
                                                                    <!-- {{item.total}} -->
                                                                    {{parseFloat(item.total).toFixed(2)}}
                                                                </v-col>
                                                            </v-row>
                                                            <v-row class="ml-0 mr-0 text-left">
                                                                <v-col cols="8" class="text-center pb-0 pt-0 pr-0">
                                                                    <!-- <v-text-field class="order-card-price" style="font-size:10px;" v-model="item.qty" @click:prepend="reduceqty(item.itemid,item.courseid)" @click:append-outer="addorderqty(item.itemid,item.courseid)" prepend-icon="mdi-minus" append-outer-icon="mdi-plus"></v-text-field> -->
                                                                </v-col>

                                                            </v-row>
                                                        </v-col>

                                                    </v-row>
                                                </v-card>
                                            <!-- </a> -->




                                                <v-card
                                                stlye="position:relative"
                                                class="Card Outline Style Here" tile v-else>
                                                    <v-row class="ma-0 pa-0">
                                                        <v-col cols="4" class=" pl-0 pr-0 pt-0 pb-0">
                                                            <v-img contain :src="item.image" class="order-card-image">
                                                            </v-img>

                                                        </v-col>
                                                        <v-col cols="8" class="ma-0 pa-0">
                                                            <v-row class="ma-0 pa-0">
                                                                <v-col cols="10" class="ma-0 pa-0">
                                                                    <p class="order-card-title">
                                                                        {{item.title}}</p>
                                                                </v-col>
                                                                <v-col cols="2" class="ma-0 pa-0 text-right">
                                                                    <!-- <img @click.stop="deleteorderitem(item.itemid,item.courseid)" :src="imgfavminus" width="32"/> -->
                                                                    <v-icon @click.stop="deleteorderitem(item.itemid,item.courseid)" class="color:red" size="24" >mdi-close</v-icon>
                                                                </v-col>
                                                                <v-col cols="12" class="ma-0 pa-0">
                                                                    <p class="order-card-subtitle">{{item.subtitle}}</p>
                                                                </v-col>
                                                                <v-col cols="12" class="order-card-price" v-if="parseFloat(item.origprice)>0.001">
                                                                    {{parseFloat(item.origprice).toFixed(2)}}
                                                                </v-col>
                                                            </v-row>
                                                                <v-row class="ma-0 pa-0" style="align-items: center;">
                                                                    <v-col cols="2">
                                                                    <span class="pa-0 ma-0" style="font-size:8px">Qty</span>
                                                                    </v-col>

                                                                    <v-col cols="6" class="pa-0 ma-0" style="font-size:8px">
                                                                    <v-text-field
                                                                        class="pa-0 ma-0 px-3"
                                                                        style="font-size:10px;text-align-last:center"
                                                                        v-model="item.qty"
                                                                        @click:prepend="reduceqty(item.itemid,item.courseid)"
                                                                        @click:append-outer="addorderqty(item.itemid,item.courseid)"
                                                                        prepend-icon="mdi-chevron-left"
                                                                        append-outer-icon="mdi-chevron-right">
                                                                    </v-text-field>
                                                                    </v-col>

                                                                <v-col cols="4" class="order-card-price" v-if="parseFloat(item.origprice)>0.001">
                                                                    {{parseFloat(item.total).toFixed(2)}}
                                                                </v-col>
                                                            </v-row>
                                                            <!-- <v-row cols="12" class="order-card-price bgr">
                                                                    {{item.total.toFixed(2)}}
                                                                </v-row> -->

                                                        </v-col>
                                                    </v-row>
                                                </v-card>

                                        </v-col>
                                    </v-row>

                            </v-col>
                        </v-row>

                        <v-divider></v-divider>

                        <v-row align="center">
                            <v-col cols="12"><strong class=" title">{{$t('zz_total')}}: {{business.currency.symbole+ordertotal}}</strong></v-col>

                        </v-row>

                        <v-expansion-panels
                        v-model="orderpanel"
                        flat
                        tile
                        class="order-delivery-panel"
                        v-if="business.hasdelivery && ordertotal>0"
                        >
                            <v-expansion-panel tile flat>
                                <v-expansion-panel-header>
                                    <p class="title">{{$t('zz_delivery')}}:</p>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <p v-if="business.deliveryfreeorder<ordertotal">FREE This is on us, Thanks For Your Order</p>
                                    <p v-else>If you order just another {{business.currency.symbole+(parseFloat(business.deliveryfreeorder)-parseFloat(ordertotal)).toFixed(2)}} you will save the delivery fee.</p>
                                    <v-row><v-col cols="12">{{business.deliverynotes}}</v-col></v-row>
                                </v-expansion-panel-content>
                            </v-expansion-panel>

                        </v-expansion-panels>
                        <v-divider></v-divider>

                        <v-form v-model="valid" ref="form"  id="createorder" v-if="business.hasdelivery==1 || business.hastakeaway==1" lazy-validation>


                            <v-row v-if="ordertotal>0">
                                <v-col cols="12" class="text-center pl-0 pr-0" >
                                    <v-radio-group v-model="ordertype" row dense @change="setordertype">
                                        <v-radio  :label="$t('zz_eatin')" value="Eat In" v-if="business.haseatin==1"></v-radio>
                                        <v-radio  :label="$t('zz_takeaway')" value="Take Away" v-if="business.hastakeaway==1"></v-radio>
                                        <v-radio  :label="$t('zz_delivery')" value="Delivery" v-if="business.hasdelivery==1"></v-radio>

                                    </v-radio-group>
                                </v-col>
                            </v-row>

                            <v-row v-if="ordertotal>0">

                                <v-col cols="12">
                                    <v-text-field
                                    v-model="ordername"
                                    name="name_zz"
                                    :label="$t('zz_name')"
                                    required
                                    :counter="20"
                                    :rules="nameRules"
                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12" v-if="ordertype=='Delivery'">
                                    <v-text-field
                                                    v-model="address1"
                                                    name="address1"
                                                    :label="$t('zz_address_line1')"
                                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" v-if="ordertype=='Delivery'">
                                    <v-text-field
                                                    v-model="address2"
                                                    name="address2"
                                                    :label="$t('zz_address_line2')"
                                                    ></v-text-field>
                                </v-col>

                                <v-col cols="4" v-if="ordertype=='Delivery'">
                                    <v-text-field
                                                    v-model="city"
                                                    name="city"
                                                    :label="$t('zz_city')"
                                                    ></v-text-field>
                                </v-col>
                                <v-col cols="4" v-if="ordertype=='Delivery'">
                                    <v-text-field
                                                    v-model="town"
                                                    name="town"
                                                    :label="$t('zz_town')"
                                                    ></v-text-field>
                                </v-col>
                                <v-col cols="4" v-if="ordertype=='Delivery'">
                                    <v-text-field
                                                    v-model="zip"
                                                    name="zip"
                                                    :label="$t('zz_postal_code')"
                                                    ></v-text-field>
                                </v-col>

                                <v-col cols="12" class="text-left " v-if="ordertype=='Delivery'">
                                    <span>{{$t('zz_pzyment_mode')}} :</span>
                                </v-col>

                                <v-col cols="12" class="text-center pl-0 pr-0" v-if="ordertype=='Delivery'">
                                    <v-radio-group v-model="paymentmode" row dense >
                                        <v-radio  label="Cash" value="Cash" ></v-radio>
                                        <v-radio  label="Card" value="Card" ></v-radio>
                                    </v-radio-group>
                                </v-col>

                                <v-col cols="12" >
                                    <v-textarea
                                    v-model="orderdetailphone"
                                    name="phone"
                                    :label="$t('zz_notes')"
                                    ></v-textarea>
                                </v-col>


                            </v-row>



                            <v-col cols="12" class="text-center pl-0 pr-0" >
                                <v-checkbox
                                v-model="createaccount"
                                :label="$t('zz_create_account_login')"



                                ></v-checkbox>
                            </v-col>


                            <v-row v-if="createaccount==1 && ordertotal>0">

                                <v-col cols="12">

                                    <v-text-field
                                    v-model="email"
                                    name="email"
                                    :label="$t('zz_email')"
                                    required
                                    v-validate="'required|email'"
                                    :error-messages="errors.collect('email')"
                                    data-vv-name="email"
                                    ></v-text-field>
                                </v-col>

                            </v-row>
                            <v-row v-if="createaccount==1 && ordertotal>0">
                                <v-col cols="12" md="12">
                                    <v-text-field
                                        v-model="password"
                                        type="password"
                                        name="password"
                                        :label="$t('zz_password')"
                                        v-validate="'required|min:6'"
                                        :error-messages="errors.collect('password')"
                                        data-vv-name="password"
                                        ref="password"

                                    ></v-text-field>
                                </v-col>

                            </v-row>


                            <v-row >
                                <v-col v-if="ordertotal>0" cols="12" class="text-left">

                                    <v-btn @click="whatsapmsg" v-if="business.paymentenabled==0" class="ma-2" tile outlined color="success">
                                        <v-icon left>mdi-whatsapp</v-icon> {{$t('zz_send_order')}}
                                    </v-btn>
                                    <v-btn  @click="saveorder" v-else class="ma-2" tile outlined color="success">
                                        <v-icon left>mdi-whatsapp</v-icon> {{$t('zz_save_and_pay_order')}}
                                    </v-btn>

                                    <v-btn style="position:fixed; bottom:5px;right:5px" class="px-10 ma-5" tile  color="success" plain large @click.prevent="$emit('set-dialog')">{{$t('zz_exit')}}</v-btn>


                                    <!-- save order and make payment -->

                                </v-col>
                                <v-col v-else cols="12" class="text-center">
                                    <v-btn style="position:fixed; bottom:5px;right:5px" class="px-10 ma-5" tile  color="success" plain large @click.prevent="$emit('set-dialog')">{{$t('zz_exit')}}</v-btn>

                                </v-col>
                            </v-row>



                        </v-form>

                        <v-col v-else cols="12" class="text-center">
                            <v-btn style="position:fixed; bottom:5px;right:5px" class="px-10 ma-5" tile color="success" plain large @click.prevent="$emit('set-dialog')">{{$t('zz_exit')}}</v-btn>

                        </v-col>

            </v-card-text>



        </v-card>

    </v-app>

</template>

<script>
    import Vue from 'vue'
    import VeeValidate from "vee-validate";




    Vue.use(VeeValidate);



    export default
    {
        props: ['orderdetail','business','otype','otyperetail'],

        data: () =>

        ({
            orderdetailphone:'',

            paymentmode:'',
            zip:'',
            town:'',
            city:'',
            address2:'',
            address1:'',
            ordername:'',
            ordertype:'',
            order:{'ordertype':'','name':'','phone':'','address':'','items':[]},

            countActivelang1:0,
            founddesc:false,
            langdesc:'',
            showpayment:0,
            savedorder:[],
            showcard:0,

            nameRules: [
            v => !!v || 'Name is required',
            v => (v && v.length <= 20) || 'Name must be less than 20 characters',
            ],
            emailRules:
            [
            v => !!v || 'E-mail is required',
            v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
            ],
            stripe:'',
            createaccount:0,
            email:'',
            password: "",
            password_confirmation: "",

            orderpanel:[0,1],
            whatsappImg:require('@/assets/whatsaap.png'),
            whatsaapNumber:'',
            strmsg:'',


            //filterImg:require('@/assets/filters.png'),
            filterImg:require('@/assets/zz-filters.svg'),
            //filterImg:require('@/assets/Serpant-health-icon.svg'),
            allergenImg:require('@/assets/Serpant-health-icon.svg'),

            exampleimg:require("@/assets/EXAMPLE.svg"),
            editicon:require("@/assets/Pen-Icon-01.svg"),
            imgicon:require("@/assets/Camera-Icon-01.svg"),
            editimageicon:require("@/assets/editphotoicon.svg"),
            //allergensimg:require("@/assets/AllergensExplainedCard.svg"),
            allergensimg:require("@/assets/AllergensExplainedCard.svg"),
            panelnew:[0,1],
            filtera:0,
            chilli:require("@/assets/chili.svg"),
                // chillio:require("@/assets/chili-o.svg"),
            chillio:require("@/assets/chili-plain.svg"),

            romeoimg: require("@/assets/Jigsaw&.svg"),
            //romeoimg: require("@/assets/Jigsaw&.png"),

            imgfavplusdrink:require("@/assets/imgfavplusdrink.svg"),
            imgfavminusdrink:require("@/assets/imgfavminusdrink.svg"),
            valid:true,
            shw:true,
            nshw:false,
            fooditemshowonmenu:0,
            itemupdateid:0,
            itemupdatecourseid:0,
            mainimguploading:false,
            uploadedimage:null,
            overlayfooditemimageupdate:false,
            image:null,
            addphoto: require("@/assets/addphoto.svg"),

            drawer:null,
            businesscode:0,
            cocacolaImg:require('@/assets/cocacola2.gif'),
            overlaycocacola:false,
            orderoverlayPlain:false,
            overlayPIN:false,
            drinkoverlayPlain:false,
            overlayfooditem:false,
            overlayfooditemdetail: false,
            orderoverlay:false,
            orderrating:0,
            allergensrating:0,
            dietrating:0,
            meatrating:0,

            // descHTMLNo:'<p style="font-size:14px;" v-html="'+food.fdesc+'"></p>',
            star:0,
            stardiet:0,
            starmeat:0,
            allergensdialog:false,
            drinkitemdialog:false,
            itemdialog:false,
            itemimagedialog:false,
            itemdialogolddesign:false,
            paydialog:0,
            orderdialog:0,
            dietSelectAll:0,
            meatSelectAll:0,
            poultrySelectAll:0,
            panelfilter:[0,1,2],
            filter:0,
            filterAllergens:0,
            removedMeats:[],
            removedDiets:[],
            removedPoultrys:[],
            selectedMeats:[],
            selectedDiets:[],
            selectedPoultrys:[],
            selectedAllergens:[],
            selectedAllergensName:[],
            currentcourse:null,
            noAllergen:0,
            panel:[],
            panelAllergens:[0,1],
            drImg:require('@/assets/dr.png'),
            bannerImg:require('@/assets/overview-banner.jpg'),
            cheficonGrid:require('@/assets/chefGrid.svg'),
            cheficonList:require('@/assets/chefList.svg'),


            featureimg:require('@/assets/FaveActiveWhiteStroke.svg'),
            heart:require('@/assets/heart.png'),
            heartout:require('@/assets/heart-out.png'),
            // imgfavplus:require('@/assets/favplus.png'),
            imgfavplus:require('@/assets/FavsplusNew.svg'),
            imgfavminus:require('@/assets/FavminusNew.svg'),
            // imgfavminus:require('@/assets/favminus.png'),
            favplus:require('@/assets/favplus.svg'),

            ordercourses:{'courses':[{'items':[]}]},

            localorder:[],
            fooditem:
                {
                "id":0,
                "showonmenu":0,
                "business_id":0,
                "department_id":0,
                "title":"",
                "subtitle":"",
                "description":"",
                "image":"",

                "chillispice":0,
                "created_at":"",
                "updated_at":"",
                "foodstatus":"",
                "viewed":0,
                "ordered":0,
                "fimage":"",
                "itemsize":[],
                "meats":[],
                "diets":[],
                "poultrys":[],
                "allergens":[],
                "courses":[],
                "drinkitems":[],
                "langtransaltions":[],
                },

            foodview:'grid',

        // bannerImg:'',
            //logoImg:require('@/assets/logo.svg'),

            itemtotal:0,

            currentorder:[{items:[]}],
            fooditemid:0,
            courseid:0,
            itemqty:1,
            drinkitem:
            {

                "viewed":0,
                "ordered":0,
                "fimage":"",
                "image":"",
                "allergens":[],
                "measures":[],
                "units":[],
                "categories":[],
                "types":[],
            },
            drinkitemid:0,
            drinkitemname:'',
            attributes: {
                email: "E-mail Address",



            },
            coursename:"",
            userlangcode:'',

        }),

    watch:
    {
        orderdetail:function(value)
        {
            // this.order=this.orderdetail;

            // this.setordercourses();

            return value;
        },
        business:function(value)
        {
            // this.order=this.orderdetail;

            this.setordercourses();

            return value;
        },
        otype:function(value)
        {
            // this.order=this.orderdetail;

            // this.setordercourses();

            return value;
        }
    },

    created()
    {
        // this.business=JSON.parse(localStorage.getItem('business')||'{}');

        // this.userlangcode=localStorage.getItem('langcode')||'';
        // console.log("business id "+this.business.id);
        console.log('corder-'+this.business.id);
        this.order=JSON.parse(localStorage.getItem('order-'+this.business.id));

            this.setordercourses();

    },


    mounted()
    {



    },
    updated()
    {
      // var elem = document.querySelector('.grid');
      // var msnry = new Masonry('.grid', {
      //   // options
      //   itemSelector: '.grid-item',
      //   columnWidth: '50%'
      // });
    },
    computed:
    {
        ordertotal:function()
        {

            let total=0;
            this.order.items.forEach(function(item,inx){
                total+=parseFloat(item.qty)*parseFloat(item.price);
            })

            return parseFloat(total).toFixed(3);
        }
    },
    methods:
    {


        whatsapmsg()
        {


            let th=this;




            let newstr=[];

            let whatsaapMsg="";

            th.whatsaapNumber=th.business.whatsapp;




            let total=0;

            if(th.ordercourses.courses.length>0)
            {
                let itemfound=false;
                let ordertotal=0;

                let paymentmode='';

                th.strmsg="\n\n\n*CLIENTE*\n\n";


                th.strmsg+="_"+th.order.name+"_\n\n";

                if(th.ordertype=='Delivery'){

                    th.strmsg+="\n"+th.address1;
                    th.strmsg+="\n"+th.address2;
                    th.strmsg+="\n"+th.city+", "+th.town;
                    th.strmsg+="\n"+th.zip;



                    if(paymentmode!='')
                    {
                        th.paymentmode=paymentmode;
                    }


                }

                let allAllerText="";

                let allAllergenname="";

                allAllergenname=JSON.parse(localStorage.getItem('jzAllergensName'));



                if(allAllergenname)
                {
                    allAllergenname.forEach(function(allergen,ind){



                        allAllerText+=allergen.replace('<br>',' ')+', ';
                    })

                    allAllerText=allAllerText.substr(0,allAllerText.length-1);

                }

                if(allAllerText=='')
                {
                    th.strmsg+="\n\n*ALLERGENS:* None declared  \n\n";

                }
                else
                {
                    th.strmsg+="\n\n*ALLERGENS:* "+allAllerText+" \n\n";
                }

                th.strmsg+="*Notes:* \n";


                th.strmsg+=this.orderdetailphone;


                th.strmsg+="\n\n.............................\n";

                th.strmsg+="*"+th.business.businessName+"* \n";

                th.strmsg+=this.$domain+"businessDetails/"+th.business.businesscode+"/drink \n\n";


                th.strmsg+="*TYPO:"+th.ordertype+"*";
                th.strmsg+="\n.............................\n";



                th.ordercourses.courses.forEach(function(item,index){

                    if(item.items.length>0)
                    {

                        th.strmsg+="\n\n*"+item.coursename+"*\n\n";

                        item.items.forEach(function(it,ind){
                            if(it.qty>0 && it.price>0)
                            {
                                th.strmsg+=it.qty+" X "+it.title+" = "+th.business.currency.symbole+(parseFloat(it.qty)*parseFloat(it.price)).toFixed(2)+"\n";


                                ordertotal+=parseFloat(it.qty)*parseFloat(it.price);
                            }
                        })




                    }



                })

                th.strmsg+="\n..........................\n";



                th.strmsg+="*Total :"+th.business.currency.symbole+ordertotal.toFixed(2)+"*";




                th.strmsg+="\n\n";

                if(th.paymentmode!='')
                {
                    th.strmsg+="*Payment Mode* :"+th.paymentmode;


                    th.strmsg+="\n\n";

                }


                th.strmsg+="*DELIVERY CHARGES:* \n";

                if(parseFloat(ordertotal)>parseFloat(th.business.deliveryfreeorder))
                {
                    th.strmsg+="FREE This is on us, Thanks For Your Order \n";

                }
                else
                {
                    th.strmsg+="If you order just another "+th.business.currency.symbole+(parseFloat(th.business.deliveryfreeorder)-parseFloat(ordertotal)).toFixed(2)+" you will save the delivery fee.";


                }




                //th.strmsg+="\n\n powered by juZZap \n\n";





                whatsaapMsg="https://wa.me/"+th.business.whatsapp+"/?text="+encodeURIComponent(th.strmsg);

                window.location=whatsaapMsg;



            }
        },

         saveorder()
        {
            let th=this;


            let msg="";
            let response="";
            if (this.$refs.form.validate())
            {

                let fd = new FormData(document.getElementById("createorder"));

                if(th.ordercourses.courses.length>0)
                {
                    let ordertotal=0;

                    let orderitems=[];

                    let createaccount=0;

                    if(th.createaccount)
                    {
                        createaccount=1;
                    }
                    else
                    {
                        createaccount=0;
                    }

                    fd.append('createaccount',createaccount);


                    fd.append('name',th.ordername);

                    fd.append('orderid','order-'+th.business.id)

                    fd.append('businesses_id',th.business.id)

                    fd.append('paymentmode',this.paymentmode)

                    th.ordercourses.courses.forEach(function(item,index)
                    {

                        if(item.items.length>0)
                        {


                            item.items.forEach(function(it,ind){
                                if(it.qty>0 && it.price>0)
                                {
                                    orderitems.push({'product_type':it.type,'course_id':it.courseid,'product_name':it.title,'product_id':it.itemid,'qty':it.qty,'price':it.price,'total':parseFloat(it.qty)*parseFloat(it.price)});
                                    ordertotal+=parseFloat(it.qty)*parseFloat(it.price);
                                }
                            })

                        }



                    })

                    fd.append('ordertotal',th.ordertotal);

                    fd.append('addressline1',th.address1);

                    fd.append('addressline2',th.address2);

                    fd.append('city',th.city);

                    fd.append('town',th.town);

                    fd.append('zip',th.zip);

                    fd.append('notes',th.orderdetailphone);

                    fd.append('orderitems',JSON.stringify(orderitems));







                }

                this.$http
                .post(this.$apidomain+"createorder", fd)
                .then(res =>
                {
                    th.msg=res.data.msg;
                    th.response=res.data.success;



                        if(res.data.success==1)
                        {
                            this.savedorder=res.data.ordermaster;
                            if(res.data.key.clientSecret!='' && this.business.paymentenabled==1)
                            {

                                this.stripe = this.business.stripapikey;
                                if(this.business.stripapikey!=''){
                                    var stripe = Stripe(this.stripe);
                                    let elements = stripe.elements();

                                    let card = elements.create("card");

                                    // Stripe injects an iframe into the DOM

                                    var style = {

                                        base: {

                                            color: "#32325d",

                                            fontFamily: 'Arial, sans-serif',

                                            fontSmoothing: "antialiased",

                                            fontSize: "16px",

                                            "::placeholder": {

                                            color: "#32325d"

                                            }

                                        },

                                        invalid: {

                                            fontFamily: 'Arial, sans-serif',

                                            color: "#fa755a",

                                            iconColor: "#fa755a"

                                        }

                                        };

                                    card.mount("#card-element", { style: style });
                                    th.showpayment=1;
                                    document.querySelector("#payment-form button").disabled = true;

                                    card.on("change", function (event)
                                    {

                                        // Disable the Pay button if there are no card details in the Element

                                        document.querySelector("#payment-form button").disabled = event.empty;

                                        document.querySelector("#card-error").textContent = event.error ? event.error.message : "";

                                    });

                                    var form = document.getElementById("payment-form");

                                    form.addEventListener("submit", function(event) {

                                    event.preventDefault();

                                    // Complete payment when the submit button is clicked

                                    th.payWithCard(stripe, card, res.data.key.clientSecret);

                                    });
                                }
                            }




                            //th.whatsapmsg()

                        }

                    this.$router.go('/');


                })
                .catch(err => {
                    //this.overlay=false;

                 console.log(err.response);
                });



            }
        },


        payWithCard(stripe, card, clientSecret)
        {

            this.loading(true);

            let th=this;

            stripe

                .confirmCardPayment(clientSecret, {

                payment_method: {

                    card: card

                }

                })

                .then(function(result) {

                if (result.error) {

                    // Show error to your customer

                    th.showError(result.error.message);

                } else {

                    // The payment succeeded!

                    th.orderComplete(result.paymentIntent.id);

                }

                });

        },

        orderComplete(paymentIntentId)
        {
         // console.log('payment id'+paymentIntentId);

            let th=this

            let savedorderid=this.savedorder.id;

            this.loading(false);


            document.querySelector(".result-message").classList.remove("hidden");

            document.querySelector("#payment-form button").disabled = true;

            let bodyFormData = new FormData();

            bodyFormData.append('paymentid', paymentIntentId);


            this.$http
                .post(this.$apidomain+"updateorder/"+savedorderid, bodyFormData)
                .then(res =>
                {
                    //alert(res.data.success);
                    localStorage.setItem('order-'+this.business.id,JSON.stringify({'ordertype':'','name':'','phone':'','address':'','items':[]}));
                    this.order=JSON.parse(localStorage.getItem('order-'+this.business.id));

                    this.showpayment=0;
                    this.ordercourses={'courses':[{'items':[]}]};


                })

        },




        favminus(itemid)
        {
            let th=this;
            let res=false;

                th.order.items.forEach(function(item){
                    if(itemid==item.itemid)
                    {
                        //console.log('remove item');
                        //th.order.items.pop({'itemid':th.fooditemid,'image':th.fooditem.fimage,'title':th.fooditem.title,'subtitle':th.fooditem.subtitle,'courseid':course.cid,'course':course.coursename,'qty':itemqty,'price':course.price,'total':itemtotal});
                        this.order.items.splice(itemid,1);

                        localStorage.setItem('order-'+this.business.id,JSON.stringify(this.order));

                    }
                    else
                    {

                        th.order.items.push({'itemid':th.fooditemid,'image':th.fooditem.fimage,'title':th.fooditem.title,'subtitle':th.fooditem.subtitle,'courseid':course.cid,'course':course.coursename,'qty':itemqty,'price':course.price,'total':itemtotal});

                    }
                });
        },
        togglefavdrink(drinkitemid,title,subtitle,img,courseid,coursename,type)
        {



                let th=this;
            let res=false;
            //alert('toggle call'+drinkitemid+' title '+title+' subtitle '+subtitle+' img '+img+ ' courseid ' + courseid + ' coursename ' + coursename+' type '+type);
            //console.log('itemid' + itemid + ' courseid ' + courseid + ' coursename ' + coursename + ' price ' + price );
            this.fooditemid=drinkitemid;
            this.drinkitemid=drinkitemid;
            if(th.order.items.length>0)
            {
                let itemfound=false;
                th.order.items.forEach(function(item,index){
                    if(drinkitemid==item.itemid && courseid==item.courseid)
                    {

                        th.order.items.splice(index,1);

                        localStorage.setItem('order-'+th.business.id,JSON.stringify(th.order));
                        itemfound=true;
                        //console.log('order minus');
                    }

                });
                if(!itemfound)
                {
                    //alert(drinkitemid+','+title+','+subtitle+','+img+','+courseid+','+coursename+','+'drink')

                    th.order.items.push({'itemid':drinkitemid,'image':img,'title':title,'subtitle':subtitle,'courseid':courseid,'course':coursename,'qty':1,'price':0,'total':0,'type':'drink'});
                    //res=false;
                    localStorage.setItem('order-'+th.business.id,JSON.stringify(th.order));
                    this.addtoorder();
                }
            }
            else
            {
                //th.order.items.push({'itemid':itemid,'image':img,'title':title,'subtitle':subtitle,'courseid':courseid,'course':coursename,'qty':1,'price':price,'total':0,'type':'drink'});
                        //res=false;
                    th.order.items.push({'itemid':drinkitemid,'image':img,'title':title,'subtitle':subtitle,'courseid':courseid,'course':coursename,'qty':1,'price':0,'total':0,'type':'drink'});

                    localStorage.setItem('order-'+th.business.id,JSON.stringify(th.order));
                   this.addtoorder();


            }

            this.drinkitemdialog=false;
            this.orderdialog=false;


        },
        adddrinkorder()
        {
            //console.log('Call Addorder');
            let th=this;
            let qty=0;


            this.$http
            .get(this.$apidomain+"drinkitemorderedupdate/"+this.drinkitemid+'/plus')
            .then(res => {

            })
            .catch(err => {
            console.log(err.response);
            });

        },
        togglefav(itemid,courseid,coursename,price,img,title,subtitle,size='')
        {
            let th=this;
            let res=false;
            let sz=[];
            let it=0;
            let ip=0;

            //console.log('size '+size);

            //console.log('itemid' + itemid + ' courseid ' + courseid + ' coursename ' + coursename + ' price ' + price +'size '+ size);
            this.fooditemid=itemid;

            if(size)
            {
                sz=size.split('|');

                //alert(sz[0]);
                //console.log('check size '+size);



                if(th.order.items.length>0)
                {
                    let itemfound=false;
                    th.order.items.forEach(function(item,index)
                    {
                        if(sz[0]=='null')
                        {
                            //alert('remove');
                            if(itemid==item.itemid && courseid==item.courseid && (item.mname=="" || item.mname=="null"))
                            {

                                //th.order.items.pop({'itemid':th.fooditemid,'image':th.fooditem.fimage,'title':th.fooditem.title,'subtitle':th.fooditem.subtitle,'courseid':course.cid,'course':course.coursename,'qty':itemqty,'price':course.price,'total':itemtotal});
                                th.order.items.splice(index,1);

                                localStorage.setItem('order-'+th.business.id,JSON.stringify(th.order));
                                itemfound=true;
                                //console.log('order minus');
                            }
                        }
                        else
                        {
                            //alert('not remove');

                            if(itemid==item.itemid && courseid==item.courseid && item.mname==sz[0])
                            {

                                //th.order.items.pop({'itemid':th.fooditemid,'image':th.fooditem.fimage,'title':th.fooditem.title,'subtitle':th.fooditem.subtitle,'courseid':course.cid,'course':course.coursename,'qty':itemqty,'price':course.price,'total':itemtotal});
                                th.order.items.splice(index,1);

                                localStorage.setItem('order-'+th.business.id,JSON.stringify(th.order));
                                itemfound=true;
                               // console.log('order minus');
                            }
                        }

                    });
                    if(!itemfound)
                    {


                        if(sz[0]!='')
                        {
                            it=title+'-'+sz[0];

                        }
                        else
                        {
                            it=title;

                        }
                        ip=sz[1];

                        //th.order.items.push({'itemid':itemid,'image':img,'title':title,'subtitle':subtitle,'courseid':courseid,'course':coursename,'qty':1,'price':price,'total':price,'type':'food'});
                        th.order.items.push({'itemid':itemid,'image':img,'title':it,'subtitle':subtitle,'courseid':courseid,'course':coursename,'qty':1,'price':parseFloat(ip),'total':parseFloat(ip),'type':'food','mname':sz[0]});

                        //res=false;
                        localStorage.setItem('order-'+th.business.id,JSON.stringify(th.order));
                        this.addtoorder();
                    }
                }
                else
                {




                    if(sz[0]!='')
                    {
                        it=title+'-'+sz[0];

                    }
                    else
                    {
                        it=title;

                    }
                    ip=sz[1];

                    //th.order.items.push({'itemid':itemid,'image':img,'title':title,'subtitle':subtitle,'courseid':courseid,'course':coursename,'qty':1,'price':price,'total':price,'type':'food'});
                            //res=false;
                    th.order.items.push({'itemid':itemid,'image':img,'title':it,'subtitle':subtitle,'courseid':courseid,'course':coursename,'qty':1,'price':parseFloat(ip),'total':parseFloat(ip),'type':'food','mname':sz[0]});

                    localStorage.setItem('order-'+th.business.id,JSON.stringify(th.order));
                    this.addtoorder();


                }
            }


        },
        addtoorder()
        {

            //console.log('Call Addorder');
            let th=this;
            let qty=0;
            th.fooditem.courses.forEach(function(course)
            {
            //let itemqty=parseInt(document.getElementById('course-'+course.courseid).value);
            let itemqty=1;
            qty=qty+itemqty;
            let itemprice=parseFloat(document.getElementById('course-'+course.courseid).getAttribute('data-price'));
            let itemtotal=itemprice*itemqty;
            if(itemtotal>0)
            {
               // console.log('cid'+course.cid);
                //th.order.items.push({'itemid':th.fooditemid,'image':th.fooditem.fimage,'title':th.fooditem.title,'subtitle':th.fooditem.subtitle,'courseid':course.cid,'course':course.coursename,'qty':itemqty,'price':course.price,'total':itemtotal});
            }

            })
            localStorage.setItem('order-'+th.business.id,JSON.stringify(th.order));

            //console.log('fooditemid'+this.fooditemid)  ;

            if(qty==0)
            {
                qty=1;
            }
            this.$http
            .get(this.$apidomain+"itemorderedupdate/"+this.fooditemid+'/'+qty+'/plus')
            .then(res => {

            })
            .catch(err => {
            console.log(err.response);
            });


            // this.resetfoodtem();
            //  this.itemdialog=false;
            //  this.overlayfooditem=false;

        },
        checkitemfavorite(itemid,courseid)
        {
            let th=this;
            let res=false;

                //alert(itemid+','+courseid);

                th.order.items.forEach(function(item){
                    if(itemid==item.itemid && courseid==item.courseid)
                    {
                        res=true;
                        //alert(res);
                    }

                });
            return res;

        },
        checkitemfavoritefood(itemid,courseid,size='')
        {
            let th=this;
            let res=false;

                // alert(itemid+','+courseid+' '+size);

                if(size!=""  && size!=null)
                {
                    th.order.items.forEach(function(item)
                    {



                            if(itemid==item.itemid && courseid==item.courseid && size==item.mname)
                            {
                                res=true;
                                // alert(itemid+','+courseid+' '+size);
                            }




                    });
                }
                else
                {
                    th.order.items.forEach(function(item)
                    {

                            //console.log('else size '+size);

                            if(itemid==item.itemid && courseid==item.courseid && (item.mname=="null" || item.mname==""))
                            {
                                res=true;
                                // alert(itemid+','+courseid+' '+size);
                            }


                          //  console.log('res '+res);

                    });

                }
            return res;
        },

        togglefavdrinknew(drinkitemid,title,subtitle,img,typeid,typename,measure='')
        {
            //console.log('toggle call'+drinkitemid+' title '+title+' subtitle '+subtitle+' img '+img);

            //alert('toggle call'+drinkitemid+' title '+title+' subtitle '+subtitle+' img '+img+' typeid '+typeid+' typename '+typename);

            let th=this;
            let res=false;
            this.drinkitemid=drinkitemid;
            let ma=[];
            let it=0;
            let ip=0;
            if(measure)
            {
                ma=measure.split('|');

                if(th.order.items.length>0)
                {
                    let itemfound=false;
                    th.order.items.forEach(function(item,index)
                    {
                        if(drinkitemid==item.itemid && item.mname==ma[0])
                        {
                            th.order.items.splice(index,1);
                            //localStorage.setItem('drinkorder-'+th.business.id,JSON.stringify(th.order));
                            localStorage.setItem('order-'+th.business.id,JSON.stringify(th.order));

                            itemfound=true;
                            //console.log('order minus');

                        }


                    });
                    if(!itemfound)
                    {
                        it=title+'-'+ma[0]+'-'+ma[2]+ma[3];
                        ip=ma[1];

                        // th.order.items.push({'drinkid':drinkitemid,'image':img,'title':title,'subtitle':subtitle,'typeid':typeid,'typename':typename});

                        // localStorage.setItem('drinkorder-'+th.business.id,JSON.stringify(th.order));



                        th.order.items.push({'itemid':drinkitemid,'image':img,'title':it,'subtitle':subtitle,'courseid':typeid,'course':typename,'qty':1,'price':parseFloat(ip),'total':parseFloat(ip),'type':'drink','mname':ma[0]});

                        localStorage.setItem('order-'+th.business.id,JSON.stringify(th.order));

                        this.addtoorder();

                    }
                }
                else
                {

                    // th.order.items.push({'drinkid':drinkitemid,'image':img,'title':title,'subtitle':subtitle,'typeid':typeid,'typename':typename});

                    // localStorage.setItem('drinkorder-'+th.business.id,JSON.stringify(th.order));
                    it=title+'-'+ma[0]+'-'+ma[2]+ma[3];
                    ip=ma[1];

                    th.order.items.push({'itemid':drinkitemid,'image':img,'title':it,'subtitle':subtitle,'courseid':typeid,'course':typename,'qty':1,'price':parseFloat(ip),'total':parseFloat(ip),'type':'drink','mname':ma[0]});

                    localStorage.setItem('order-'+th.business.id,JSON.stringify(th.order));


                    this.addtoorder();
                }
            }







        },

        checkitemfavoritedrink(itemid,typeid,mname='')
        {
            let th=this;
            let res=false;




                th.order.items.forEach(function(item){
                    if(itemid==item.itemid && typeid==item.courseid && mname==item.mname)
                    {
                        res=true;

                    }

                });
            return res;

        },
        addqty(itemid,courseid)
        {

        },

        reduceqty(itemid,courseid)
        {
            let th=this;

            th.order.items.forEach(function(item,index){
                if(item.itemid==itemid && item.courseid==courseid)
                {

                    //th.order.items.splice(index,1);
                    if(item.qty>0)
                    {
                        item.qty--;
                        item.total=parseFloat(item.qty)*parseFloat(item.price);

                    }
                }
            });

            localStorage.setItem('order-'+this.business.id,JSON.stringify(this.order));

            this.setordercourses();
        },
        setordertype()
        {

            localStorage.setItem('order-'+this.business.id,JSON.stringify(this.order));

            this.setordercourses();

            if(this.ordertype=='Delivery')
            {
                //alert('delivery');
                this.orderpanel=0;
            }
            else
            {
                this.orderpanel=1;

            }
        },
        addorderqty(itemid,courseid)
        {
            let th=this;

            th.order.items.forEach(function(item,index){
                if(item.itemid==itemid && item.courseid==courseid)
                {

                    //th.order.items.splice(index,1);
                    item.qty++;
                    item.total=parseFloat(item.qty)*parseFloat(item.price);
                }
            });

            localStorage.setItem('order-'+this.business.id,JSON.stringify(this.order));

            this.setordercourses();
        },
        deleteorderitem(itemid,courseid){

            let th=this;

            th.order.items.forEach(function(item,index){
                if(item.itemid==itemid && item.courseid==courseid)
                {
                    th.order.items.splice(index,1);

                }
            });
          // this.order.items.splice(ind,1);

            localStorage.setItem('order-'+this.business.id,JSON.stringify(this.order));

            this.setordercourses();



            this.$emit('setordercoursesitem');

            //  this.$emit("setordercoursesitem", true);

            // this.$http
            //   .get(this.$apidomain+"itemorderedupdate/"+this.fooditemid+'/'+delitem.qty+'/minus')
            //   .then(res => {

            //    })
            //   .catch(err => {
            //     console.log(err.response);
            //   });

            //this.calculatetotals();


          },



        fooditemdetails(fiid,crid,type,separator)
        {
           // this.$router.push({name:'eventdetails',params:{id: eventid,businessid:this.business_id}});
          // this.$emit('eventclick',eventid);

            //this.orderdialog=false;
            //alert(type);
            if(separator){
                return false;
            }
            if(this.itemimagedialog==true)
            {
                this.itemdialog=false;

            }
            else
            {




                //this.overlayPIN=true;

                if(type=='food')
                {

                    if(this.business.sponsored==1)
                    {
                        this.overlayPIN=true;
                        this.overlaycocacola=true;
                    }
                    else
                    {
                        this.overlayfooditem=true;
                        this.orderoverlayPlain=true;
                    }



                    this.$http
                    .get(this.$apidomain+"fooditemDatanew/"+fiid+'/'+crid)
                    .then(res =>
                    {
                        this.fooditem = res.data.item;

                        this.fooditemid = fiid;

                        this.courseid = crid;

                        this.coursename=this.fooditem.courses[0].coursename;




                        this.$http
                            .get(this.$apidomain+"itemviewupdate/"+fiid)
                            .then(res => {
                                this.overlayfooditem=false;
                                this.itemdialog=true;
                                this.overlayPIN=false;

                                this.overlaycocacola=false;
                                this.orderoverlayPlain=false;

                            })
                            .catch(err => {
                            console.log(err.response);
                            this.overlayPIN=false;

                            this.overlaycocacola=false;
                            this.orderoverlayPlain=false;
                        });
                    //this.itemdialog=1;
                    })
                    .catch(err =>
                    {
                        console.log(err.response);
                        this.overlayPIN=false;

                            this.overlaycocacola=false;
                            this.orderoverlayPlain=false;
                    });
                    //EventBus.$emit('fooditemclick', {'fooditemid':fooditemid,'courseid':courseid});

                }

                if(type=='drink')
                {

                    this.orderoverlayPlain=true;
                    // this.drinkitemdialog=true;
                    // this.drinkitemid=fiid;

                    this.$http
                    .get(this.$apidomain+"drinkitemDatanew/"+fiid)
                    .then(res =>
                    {
                        //this.drinkitem = res.data.item;


                        this.drinkitem = res.data.item;


                        this.drinkitemid = fiid;
                        this.courseid = crid;


                        this.drinkitemdialog=true;


                        this.itemoverlayPlain=false;

                        this.orderoverlayPlain=false;


                        // this.$http
                        //     .get(this.$apidomain+"itemviewupdate/"+fiid)
                        //     .then(res => {
                        //         this.overlayfooditem=false;
                        //         this.itemdialog=true;
                        //         this.overlayPIN=false;

                        //         this.overlaycocacola=false;
                        //         this.orderoverlayPlain=false;

                        //     })
                        //     .catch(err => {
                        //     console.log(err.response);
                        // });
                        //this.itemdialog=1;
                    })
                    .catch(err => {
                        console.log(err.response);
                        this.itemoverlayPlain=false;
                        this.orderoverlayPlain=false;

                    });

                }



            }
        },
        addqty(courseid)
        {
            document.getElementById('course-'+courseid).value = parseInt(document.getElementById('course-'+courseid).value)+1;
            //console.log(document.getElementById('course-'+courseid).getAttribute('data-price')*parseInt(document.getElementById('course-'+courseid).value));
            this.setitemtotal(courseid);
        },

        subtractqty(courseid)
        {
            if(parseInt(document.getElementById('course-'+courseid).value)>0){
              document.getElementById('course-'+courseid).value = parseInt(document.getElementById('course-'+courseid).value)-1;

               // this.itemtotal=(document.getElementById('course-'+courseid).getAttribute('data-price')*parseInt(document.getElementById('course-'+courseid).value)).toFixed(2) ;
              this.setitemtotal(courseid);
            }
        },

        setitemtotal(courseid)
        {
              let total=0;
              this.fooditem.courses.forEach(function(course){
                let itemqty=parseInt(document.getElementById('course-'+course.courseid).value);
                let itemprice=parseFloat(document.getElementById('course-'+course.courseid).getAttribute('data-price'));
                let itemtotal=itemprice*itemqty;

                total=total+itemtotal;
              });
              document.getElementById('tp-total').innerHTML=parseFloat(total).toFixed(2);
        },


        setordercourses(){
            if(this.order.items.length>0)
            {
                let th=this;
                th.ordercourses={'courses':[{'items':[]}]};

                th.order.items.forEach(function(item,index){

                    if(th.ordercourses.courses.length==0){
                        let cr={
                            courseid:item.courseid,
                            coursename: item.course,
                            type:item.type,
                            items:[]
                        };
                        cr.items.push(item);
                        th.ordercourses.courses.push(cr);
                    }
                    else{
                        let coursefound=false;
                        th.ordercourses.courses.forEach(function(course,ind){
                            if(course.courseid==item.courseid && course.type==item.type){
                               // course.items.push($item);
                                th.ordercourses.courses[ind].items.push(item);
                                coursefound=true;
                            }
                        });
                        if(!coursefound){
                            let cr={
                                courseid:item.courseid,
                                coursename: item.course,
                                type:item.type,
                                items:[]
                            };
                            cr.items.push(item);
                            th.ordercourses.courses.push(cr);
                        }
                    }
                });
            }
            else
            {
                this.ordercourses={'courses':[{'items':[]}]};

            }

        },
        gotoorder()
        {
          this.orderoverlay=true;
          this.setordercourses();
          //this.$router.push({'name':'order'});
          this.showpayment=0;
          this.orderdialog=1;
          this.orderoverlay=false;
        }
    }
}


</script>
